import { axiosClient } from 'lib/axiosClient';

export const createRole = ({ data: payload }) => {
	return axiosClient.post(`/roles`, payload);
};

export const updateRole = ({ data: payload, roleId }) => {
	return axiosClient.put(`/roles/${roleId}`, payload);
};

export const getRole = ({ roleId }) => {
	return axiosClient.get(`/roles/${roleId}`);
};

export const getRoles = (filterParams = '') => {
	return axiosClient.get('/roles');
};

export const getRolesByDept = deptId => {
	return axiosClient.get(`/roles/department/${deptId}`);
};

export const hasAdminRole = () => {
	return axiosClient.get(`/auth/hasAdminAccess`);
};
